<div
  [ngClass]="{
    'h-24 cursor-pointer px-4 py-6': true,
    'bg-[var(--messages-active)]': isActive(),
  }"
  matRipple>
  <div class="flex flex-row">
    <span class="flex w-1/6 items-center justify-center">
      <app-message-name-avatar name="Boris Joskic"></app-message-name-avatar>
    </span>
    <div class="flex w-4/6 flex-col">
      <span class="text-base text-[var(--neutral-30)]">Fleet group: {{ isActive() ? 'yes' : 'no' }}</span>
      <span class="text-md text-[var(--neutral-50)]">Mike: Trailer 24 joined the site.</span>
    </div>

    <span class="w-1/6 text-right">
      <span class="text-sm text-[var(--neutral-50)]">12:24 PM</span>
    </span>
  </div>
</div>
